"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.button.title': 'Pokaż skróty klawiszowe',
};
